import React from "react";
import SamaveshLogo from "../../../assets/samavesh.svg";

// Mobile-only SAMAVESH header shown at the top of the auth screens' form
// column. Hidden on md+. Uses -mx-5 to break out of the form column's px-5
// padding.
//
// The Government-of-India bar is deliberately NOT here: AuthGovBar renders it
// for both mobile and desktop. Duplicating it would create a second
// .bhashini-plugin-container, and the Bhashini script injects into the first
// match it finds — leaving whichever container is visible empty.
const AuthMobileHeader: React.FC = () => (
  <div className="md:hidden -mx-5 -mt-4 mb-2 px-5 py-3 bg-[#E5EFF9] flex items-center gap-3">
    <img
      src={SamaveshLogo}
      width={92}
      height={92}
      alt="samavesh-logo"
      className="h-12 w-12 shrink-0"
    />
    <div className="leading-tight">
      <h2 className="text-lg font-bold text-[#1F2937]">SAMAVESH</h2>
      <p className="text-[11px] text-gray-500 leading-snug">
        Single Access Mechanism for All Verticals of Empowerment &amp; Social
        Harmony
      </p>
    </div>
  </div>
);

export default AuthMobileHeader;
